import { createFileRoute } from '@tanstack/react-router'
import { DateLocaleSettings } from '@/features/settings/ui/date-locale-settings'

export const Route = createFileRoute('/_authenticated/account/date-and-locale')({
	component: DateAndLocalePage,
})

function DateAndLocalePage() {
	return <DateLocaleSettings />
}
